import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DashboardService } from '../dashboard.service';
import { NotificationBuilder } from '../../shared/notificationBuilder'
import * as Chartist from 'chartist';
import { AdminMetrics } from '../../models/metric.model';
import { Router, ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-admin-metrics',
  templateUrl: './admin-metrics.component.html',
  styleUrls: ['./admin-metrics.component.css']
})
export class AdminMetricsComponent implements OnInit {

  adminMetric: AdminMetrics
  take: number
  lastUpdateDate: any;
  constructor(public dashboardService: DashboardService, public ngxSmartModalService: NgxSmartModalService, public router: Router, private route: ActivatedRoute, private notificationBuilder: NotificationBuilder) {
  }

  ngOnInit() {
    this.take = 30
    this.route.queryParamMap.subscribe(params => {
      debugger
      if (params["params"].take) {
        this.take = params["params"].take
      }

      this.dashboardService.getAdminMetrics(this.take).subscribe(data => {
        debugger
        console.log(data);
        this.adminMetric = data

        this.renderCharts(true)

        try {
          debugger
          var d = new Date(data.logMetrics[0].date);
          d.setHours(d.getHours() - 3);
          this.lastUpdateDate = d
        }
        catch (e) {

        }
      })
    })
  }

  fixPriceDonation(orderId) {
    this.dashboardService.adminFixTotalPrice(orderId);
  }

  renderCharts(hasData) {
    setTimeout(() => {
      if (hasData) {
        //Purchase Chart
        var arrLabel = [];
        var arrTotalTransaction = [];
        var arrTotalPurchase = [];
        var arrTotalErrors = [];

        this.adminMetric.logMetrics.forEach(function (log) {
          var d = new Date(log.date)
          arrLabel.push(d.getHours() + ":" + d.getMinutes())
          arrTotalTransaction.push(log.countTransactions)
          arrTotalPurchase.push(log.countPurchases)
          arrTotalErrors.push(log.totalErrors)
        });

        var dataLog = {
          labels: arrLabel,
          series: [
            arrTotalTransaction, arrTotalPurchase, arrTotalErrors
          ]
        };

        var optionsLog = {
          lineSmooth: true,
          //   height: "200px",
          axisY: {
            offset: 40,
            labelInterpolationFnc: function (value) {
              return value;
            }
          },
          low: 0,
          showArea: true,
          showPoint: true,
          fullWidth: true,
          height: "250px",
        };

        var chartStock = new Chartist.Line('#chartLogs', dataLog, optionsLog);

        var dataPurchases = {
          labels: arrLabel,
          series: [arrTotalPurchase
          ]
        };

        var optionsPurchases = {
          lineSmooth: true,
          //   height: "200px",
          axisY: {
            offset: 40,
            labelInterpolationFnc: function (value) {
              return value;
            }
          },
          low: 0,
          showArea: true,
          showPoint: true,
          fullWidth: true,
          height: "250px",
        };

        var chartStock = new Chartist.Line('#chartPurchases', dataPurchases, optionsPurchases);
      }
    }, 500)
  }

}
